/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const THEME = "THEME";

/* SOCKET */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";

/* PROFILE */
export const SET_PROFILE = "SET_PROFILE";

/* USERS */
export const SET_USER_LIST = "SET_USER_LIST";
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USERS_FORM = "OPEN_USERS_FORM";
export const CLOSE_USERS_FORM = "CLOSE_USERS_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";

/* TICKET */
export const SET_TICKET_LIST = "SET_TICKET_LIST";
export const ADD_NEW_TICKET = "ADD_NEW_TICKET";
export const UPDATE_TICKET = "UPDATE_TICKET";
export const DELETE_TICKET = "DELETE_TICKET";
export const OPEN_TICKET_FORM = "OPEN_TICKET_FORM";
export const CLOSE_TICKET_FORM = "CLOSE_TICKET_FORM";
export const EDIT_SELECTED_TICKET = "EDIT_SELECTED_TICKET";
export const TICKET_FORM_TOOGLE_LOADING = "TICKET_FORM_TOOGLE_LOADING";

/* APPLICATION */
export const SET_APPLICATION_LIST = "SET_APPLICATION_LIST";
export const ADD_NEW_APPLICATION = "ADD_NEW_APPLICATION";
export const UPDATE_APPLICATION = "UPDATE_APPLICATION";
export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const OPEN_APPLICATION_FORM = "OPEN_APPLICATION_FORM";
export const CLOSE_APPLICATION_FORM = "CLOSE_APPLICATION_FORM";
export const EDIT_SELECTED_APPLICATION = "EDIT_SELECTED_APPLICATION";
export const APPLICATION_FORM_TOOGLE_LOADING = "APPLICATION_FORM_TOOGLE_LOADING";

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const DELETE_ALERT = "DELETE_ALERT";
